import { selectAuthCurrent } from "@/redux/auth/selectors";
import { useSelector } from "react-redux";

export function useRoleChecker(role) {
    const { user } = useSelector(selectAuthCurrent)
    return user?.role === role;
}